<div
    class="table__overflow"
    *ngIf="project; else loading">
    <table
        mat-table
        [dataSource]="project.defaultLinkedEmployees"
        matSort>
        <ng-container matColumnDef="employees">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>
                Employee
            </th>
            <td
                mat-cell
                *matCellDef="let linkedEmployee">
                <app-pill-employee [employeeId]="linkedEmployee.employeeId"></app-pill-employee>
            </td>
        </ng-container>

        <ng-container matColumnDef="price per hour">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>
                Hourly rate
            </th>
            <td
                mat-cell
                *matCellDef="let linkedEmployee">
                {{ linkedEmployee.pricePerHour }}
            </td>
        </ng-container>

        <ng-container matColumnDef="budget">
            <th mat-header-cell *matHeaderCellDef>Budget (€)</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                <ng-container *ngIf="linkedEmployee.budget != null; else noBudgetValue">
                    <div>{{ linkedEmployee.budget | number: '1.2-2' }}</div>
                    <small><strong>Budget by worklogs</strong></small>
                    <div
                        class="budget-progress"
                        [matTooltip]="getBudgetProgressTooltip(linkedEmployee)"
                        matTooltipPosition="above"
                        matTooltipShowDelay="150"
                        matTooltipClass="budget-tooltip">
                        <mat-progress-bar
                            class="budget-progress__track"
                            [value]="getBudgetProgress(linkedEmployee)"
                            [ngClass]="{ 'warning': getBudgetProgressRaw(linkedEmployee) >= 70 && getBudgetProgressRaw(linkedEmployee) <= 100, 'danger': getBudgetProgressRaw(linkedEmployee) > 100 }"
                            mode="determinate">
                        </mat-progress-bar>
                        <span class="budget-progress__label">{{ getBudgetProgressRaw(linkedEmployee) | number: '1.0-0' }}%</span>
                    </div>
                    <small>
                        € {{ getActualCost(linkedEmployee) | number: '1.2-2' }} / € {{ linkedEmployee.budget | number: '1.2-2' }}
                        <span *ngIf="getBudgetProgressRaw(linkedEmployee) > 100">(over budget)</span>
                    </small>
                    <small class="d-block m-t-1"><strong>Budget by invoice</strong></small>
                    <div
                        class="budget-progress"
                        [matTooltip]="getBudgetByInvoiceTooltip(linkedEmployee)"
                        matTooltipPosition="above"
                        matTooltipShowDelay="150"
                        matTooltipClass="budget-tooltip">
                        <mat-progress-bar
                            class="budget-progress__track"
                            [value]="getBudgetByInvoiceProgress(linkedEmployee)"
                            [ngClass]="{ 'warning': getBudgetByInvoiceProgressRaw(linkedEmployee) >= 70 && getBudgetByInvoiceProgressRaw(linkedEmployee) <= 100, 'danger': getBudgetByInvoiceProgressRaw(linkedEmployee) > 100 }"
                            mode="determinate">
                        </mat-progress-bar>
                        <span class="budget-progress__label">{{ getBudgetByInvoiceProgressRaw(linkedEmployee) | number: '1.0-0' }}%</span>
                    </div>
                    <small>
                        € {{ getInvoiceAmountForContract(linkedEmployee) | number: '1.2-2' }} / € {{ linkedEmployee.budget | number: '1.2-2' }}
                        <span *ngIf="getBudgetByInvoiceProgressRaw(linkedEmployee) > 100">(over budget)</span>
                    </small>
                </ng-container>
                <ng-template #noBudgetValue>-</ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="budgeted hours">
            <th mat-header-cell *matHeaderCellDef>Budgeted hours</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ getBudgetedHours(linkedEmployee) != null ? (getBudgetedHours(linkedEmployee) | number: '1.2-2') : '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actual hours">
            <th mat-header-cell *matHeaderCellDef>Actual hours</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ getActualHours(linkedEmployee) | number: '1.2-2' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="hours left">
            <th mat-header-cell *matHeaderCellDef>Hours left</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ getHoursLeft(linkedEmployee) != null ? (getHoursLeft(linkedEmployee) | number: '1.2-2') : '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="effective from">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>
                Effective From
            </th>
            <td
                mat-cell
                *matCellDef="let linkedEmployee">
                {{ linkedEmployee.effectiveFrom || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="effective to">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>
                Effective To
            </th>
            <td
                mat-cell
                *matCellDef="let linkedEmployee">
                {{ linkedEmployee.effectiveTo || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="po number">
            <th mat-header-cell *matHeaderCellDef>Purchase order (PO)</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ linkedEmployee.poNumber || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="ses number">
            <th mat-header-cell *matHeaderCellDef>SES / invoicing approval</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ linkedEmployee.sesNumber || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="contract number">
            <th mat-header-cell *matHeaderCellDef>MSA / reference</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ linkedEmployee.contractAgreementNumber || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="free text">
            <th mat-header-cell *matHeaderCellDef>Invoice free text</th>
            <td mat-cell *matCellDef="let linkedEmployee">
                {{ linkedEmployee.freeText || '-' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="client contract">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header>
                Document
            </th>
            <td
                mat-cell
                *matCellDef="let linkedEmployee">
                <ng-container *ngIf="linkedEmployee.hasClientContract && linkedEmployee.clientContractUrl; else noClientContract">
                    <a
                        [href]="linkedEmployee.clientContractUrl"
                        download
                        target="_blank"
                        title="Download client contract">
                        <i class="las la-paperclip"></i>
                    </a>
                </ng-container>
                <ng-template #noClientContract>-</ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="td-small"></th>
            <td mat-cell *matCellDef="let linkedEmployee" class="td-small">
                <a (click)="openEditDefaultEmployee(linkedEmployee)">
                    <p style="color: #007bff; cursor: pointer; margin-bottom: 4px;">
                        <i class="las la-pen"></i>
                    </p>
                </a>
                <a (click)="deleteDefaultEmployee(linkedEmployee)">
                    <p style="color: red; cursor: pointer">
                        <i class="las la-trash"></i>
                    </p>
                </a>
            </td>
        </ng-container>

        <ng-container matColumnDef="add">
            <td
                mat-footer-cell
                *matFooterCellDef
                colspan="14"
                class="table-view__add"
                (click)="openAddDefaultEmployee()">
                <i class="las la-plus"></i> New consultancy contract
            </td>
        </ng-container>

        <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns"></tr>

        <tr
            cdkDrag
            mat-row
            *matRowDef="let row; columns: displayedColumns"></tr>
        <!-- An empty table used to show nothing but its headers, which reads as broken rather than empty. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">No results.</td>
        </tr>

        <tr
            mat-footer-row
            *matFooterRowDef="['add']"></tr>
    </table>

    <div class="freelancer-monthly-overview m-t-3" *ngIf="hasFreelancerContracts()">
        <h4>Freelancer factuuroverzicht per contract</h4>

        <div class="freelancer-contract-card" *ngFor="let contract of getFreelancerContracts()">
            <div class="freelancer-contract-card__header">
                <div>
                    <strong>{{ getEmployeeNameForContract(contract) }}</strong>
                    <div class="text-muted small">
                        Contractperiode: {{ contract.effectiveFrom || '-' }} → {{ contract.effectiveTo || 'open einde' }}
                    </div>
                </div>

                <div class="freelancer-contract-card__year-filter">
                    <label>Jaar</label>
                    <select
                        [ngModel]="getSelectedYearForContract(contract)"
                        (ngModelChange)="onContractYearChange(contract, $event)">
                        <option *ngFor="let year of getContractYearOptions(contract)" [ngValue]="year">{{ year }}</option>
                    </select>
                </div>
            </div>

            <table class="freelancer-monthly-overview__table">
                <thead>
                    <tr>
                        <th>Maand</th>
                        <th>Inkomend (€)</th>
                        <th>Uitgaand (€)</th>
                        <th>Marge (€)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of getFreelancerMonthlyOverviewForContract(contract)">
                        <td>{{ row.monthLabel }}</td>
                        <td>{{ row.incoming | number: '1.2-2' }}</td>
                        <td>{{ row.outgoing | number: '1.2-2' }}</td>
                        <td [ngClass]="{ 'color--red': row.margin < 0, 'color--green': row.margin > 0 }">
                            {{ row.margin | number: '1.2-2' }}
                            <span class="text-muted small" *ngIf="row.marginPercentage !== null">({{ row.marginPercentage | number: '1.0-2' }}%)</span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>Totaal</th>
                        <th>{{ getFreelancerYearTotals(contract).incoming | number: '1.2-2' }}</th>
                        <th>{{ getFreelancerYearTotals(contract).outgoing | number: '1.2-2' }}</th>
                        <th [ngClass]="{ 'color--red': getFreelancerYearTotals(contract).margin < 0, 'color--green': getFreelancerYearTotals(contract).margin > 0 }">
                            {{ getFreelancerYearTotals(contract).margin | number: '1.2-2' }}
                            <span class="text-muted small" *ngIf="getFreelancerYearTotals(contract).marginPercentage !== null">
                                ({{ getFreelancerYearTotals(contract).marginPercentage | number: '1.0-2' }}%)
                            </span>
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="form-group m-t-3">
        <label for="projectContractFreeText">Free text to include on the invoice for this project</label>
        <textarea
            id="projectContractFreeText"
            rows="3"
            [(ngModel)]="contractFreeText"
            (blur)="saveProjectContractFreeText()"
            placeholder="Free text at project level"></textarea>
    </div>
</div>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
